const labelColors = {
  seError: '#B10043',
  sePrimary: '#008A16',
  seWarn: '#e47f00',
};

const { seError, sePrimary, seWarn } = labelColors;

export const commStatusForWMS = {
  '03': {
    type: 'RANGE_END_OF_SALE',
    label: 'Discontinued',
    color: seError,
  },
  '04': {
    type: 'RANGE_COMING_SOON',
    label: 'Coming soon',
    color: sePrimary,
  },
  '05': {
    type: 'RANGE_TO_BE_DISCONTINUED',
    label: 'To be discontinued',
    color: seWarn,
  },
  '06': {
    type: 'PRODUCT_COMING_SOON',
    label: 'Coming soon',
    firstType: 'PRODUCT_LAUNCHING',
    firstLabel: 'Launching',
    color: sePrimary,
  },
  '14': {
    type: 'PRODUCT_TO_BE_DISCONTINUED',
    label: 'To be discontinued',
    color: seWarn,
  },
  '16': {
    type: 'PRODUCT_RESTRICTED_SALES_FOR_SERVICES',
    label: 'Discontinued - Service only',
    color: seWarn,
    firstType: 'PRODUCT_END_OF_SERVICE',
    firstLabel: 'To be end of service',
    secondType: 'PRODUCT_RESTRICTED_SALES_FOR_SERVICES',
    secondLabel: 'Discontinued - Service only',
  },
  '18': {
    type: 'PRODUCT_END_OF_SALE',
    label: 'Discontinued',
    color: seError,
  },
  '19': {
    type: 'PRODUCT_END_OF_SALE_BLOCK',
    label: 'Discontinued',
    color: seError,
  },
};
